!function (p) {
    "use strict";
    p.fn.snipper = function (t) {
        var l = p.extend({}, p.fn.snipper.defaults, t);
        return this.each(function () {
            var t = p(this), e = l.fullText || t.data("snipper:fullText"), n = l.height, i = l.ellipsis || "";
            "function" == typeof n && (n = n.apply(this)), n && (n = parseInt(n, 10), isNaN(n) || (e ? ("function" == typeof e && (e = e.apply(this)), t.html(e)) : t.data("snipper:fullText", t.html()), function (t, e, n) {
                for (var i = n.replace(/&[^;]+?;/g, ".").length; t.get(0).scrollHeight > e && !(t.text().length <= i);) t.html(function (t, e) {
                    return /\s/.test(e) ? e.replace(/\s*(\S)*$/, n) : e.replace(new RegEx(".{" + (i + 1) + "}$"), n)
                })
            }(t, n, i)))
        }), this
    }, p.fn.snipper.defaults = {ellipsis: "&hellip;"}
}(jQuery);
